import React from "react"
import { Link } from "gatsby"
import styled from "styled-components/macro"
import colors from "../../scripts/colors.ts"
import "@fontsource/noto-sans-jp/700.css"
import Button from "../Button/Button"
import ArticleIcon from "../../images/iconmonstr-file-24.svg"
import ArrowIcon from "../../images/iconmonstr-arrow-24---outline---rt.svg"
import { paramCase } from "param-case"
import { decode } from "js-base64"

const ArchiveNewsItemStyles = styled.article`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  flex: 0 0 1;
  margin-bottom: 50px;
  width: 100%;
  .Button {
    display: inline-flex;
  }
  @media screen and (min-width: 1024px) {
    flex-direction: row;
    width: 47%;
  }
`

const BannerWrap = styled.div`
  display: flex;
  align-items: stretch;
  margin-bottom: 25px;
  @media screen and (min-width: 1024px) {
    margin-bottom: 0;
  }
`

const BannerItemDecoration = styled.div`
  position: relative;
  display: flex;
  align-items: stretch;
  margin-right: 4px;
`

const BannerItemLine = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  width: 3px;
  background-color: ${colors("grey", "xlt")};
`

const BannerItemIcon = styled(ArrowIcon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* transform: rotate(90deg); */
  height: 30px;
  color: ${colors("purple")};
`

const Banner = styled.div`
  flex: 0 0 auto;
  display: flex;
  margin-right: 20px;
  border: 1px solid ${colors("grey", "dk")};
`

const BannerImg = styled.img`
  display: block;
  width: 200px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
`

const Text = styled.div``

const Date = styled.p`
  font-family: "Noto Sans JP", sans-serif;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 13px;
  color: ${colors("grey", "dk")};
  margin: 0 0 5px;
  line-height: 1em;
`

const Title = styled.h2`
  margin: 0 0 10px;
  font-size: 30px;
  line-height: 1.35em;
`

const Summary = styled.p`
  margin: 0 0 20px;
  font-size: 20px;
  line-height: 1.63em;
  font-style: italic;
  color: ${colors("grey", "dk")};
`

const ArchiveNewsItem = ({ id, articleData }) => {
  const imgId = JSON.parse(
    decode(articleData.bannerImage.asset.source.id)
  ).public_id

  return (
    <ArchiveNewsItemStyles key={id}>
      {articleData.bannerImage && (
        <BannerWrap>
          <BannerItemDecoration>
            <BannerItemLine />
            <BannerItemIcon />
          </BannerItemDecoration>
          <Banner>
            <BannerImg
              loading="lazy"
              src={`https://res.cloudinary.com/agoraservices/w_600,q_auto,f_auto/${imgId}`}
              alt={articleData.title}
            />
          </Banner>
        </BannerWrap>
      )}
      <Content>
        <Text>
          <Date>{articleData.date}</Date>
          <Title>{articleData.title}</Title>
          {articleData.summary && <Summary>{articleData.summary}</Summary>}
        </Text>
        <Button
          size="sm"
          element={Link}
          to={`/news/${paramCase(articleData.title)}`}
          icon={<ArticleIcon />}
        >
          Read Article
        </Button>
      </Content>
    </ArchiveNewsItemStyles>
  )
}

export default ArchiveNewsItem
